<template>
    <div class="relative flex items-center">
        <input :type="type"
               :name="name"
               :placeholder="placeholder"
               class="w-full"
               :class="inputClasses"
               v-model="input"
               required
               @blur="checkInput"
               @keyup="update"
        >
        <div v-show="!inputState.ok && inputState.checked" class="absolute pin-r px-4">
            <i class="fas fa-times-circle text-red"></i>
        </div>
        <div v-show="inputState.ok && inputState.checked" class="absolute pin-r px-4">
            <i class="fas fa-check-circle text-green"></i>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {required: true},
            type: {default: 'text'},
            url: {required: true},
            placeholder: {default: ''},
            name: {default:''}
        },

        data() {
            return {
                inputState: {
                    checked: false,
                    ok: true
                },

                input: this.value
            }
        },

        computed: {
            inputClasses() {
                if (!this.inputState.ok && this.inputState.checked) {
                    return 'border border-red font-bold text-red-dark'
                }

                if (this.inputState.ok && this.inputState.checked) {
                    return 'border border-green font-bold text-green-600'
                }
            }
        },

        methods: {
            update() {
                this.$emit('input', this.input)
            },

            checkInput() {
                axios.get(`${this.url}${this.input}`)
                    .then(({data}) => {
                        if (data.checked) {
                            this.inputState.ok = false;
                            this.inputState.checked = true;
                        } else {
                            this.inputState.ok = true;
                            this.inputState.checked = true;
                        }
                    })
            }

        }

    }
</script>
